export default __webpack_public_path__ + "static/media/roboto-v20-latin-700italic.7d8125ff.woff2";